export const TYPES = [
  'Editorial',
  'Video',
  'VAST Video',
  'Native',
  'InStream',
];

export const SIZES = {
  Other: [
    '300x600',
    '300x250',
    '970x250',
  ],
  Native: [
    '1200x627',
    '600x600',
  ],
};
